export default function ISFJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “مدافع”</h1>{" "}
          <blockquote>
            <p>
              عشق تنها وقتی قسمت شود رشد می&zwnj;کند. تنها با بخشیدن آن به
              دیگران است که می&zwnj;توانید از آن بیشتر بهره داشته باشید.
            </p>{" "}
            <footer>Brian Tracy</footer>
          </blockquote>{" "}
          <p>
            گونه شخصیتی مدافع کاملاً منحصر به فرد است، زیرا بسیاری از
            کیفیت&zwnj;های آن از تعریف صفات فردی&zwnj;اش سرپیچی می&zwnj;کند.
            هرچند مدافعان اهل همدلی هستند، اما وقتی به محافظت از خانواده یا
            دوستان نیاز باشد خشن می&zwnj;شوند؛ هر چند آرام و کم&zwnj;حرف هستند،
            معمولاً افرادی با مهارت&zwnj;های به&zwnj;خوبی توسعه یافته و روابط
            اجتماعی قوی هستند؛ و هر چند به دنبال امنیت و ثبات هستند، ممکن است به
            میزان قابل ملاحظه&zwnj;ای دست به تغییر بزنند، البته تا زمانی که
            احساس کنند مورد درک و احترام هستند. افراد دارای گونه شخصیتی مدافع،
            همانند بسیاری از چیزهای دیگر، چیزی بیش از مجموع اجزای خود هستند، و
            شیوه استفاده آنها از این نقاط قوت است که تعریف می&zwnj;کند چه کسانی
            هستند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              مدافعان به&zwnj;راستی نوع&zwnj;دوست هستند و مهربانی را با مهربانی
              بیش از حد و درگیر شدن در کار و همکاری با اشتیاق و سخاوت با کسانی
              که به آنها باور دارند پاسخ می&zwnj;دهند.
            </p>
          </blockquote>{" "}
          <p>
            هیچ گونه شخصیتی بهتر از این گونه وجود ندارد که بخش بزرگی از جمعیت و
            نزدیک به 13% را تشکیل دهد. مدافعان با ترکیب بهترین بخش سنت و تمایل
            به انجام کارهای خوب، در کارهایی با سابقه تاریخی مانند پزشکی، کارهای
            دانشگاهی و مددکاری اجتماعی خیریه قابل مشاهده هستند.
          </p>{" "}
          <p>
            شخصیت&zwnj;های مدافع، به ویژه محتاط، اغلب تا سرحد کمال دقیق هستند، و
            اگرچه گاهی تعلل می&zwnj;کنند، همیشه می&zwnj;توان برای انجام به موقع
            کارها به آنها تکیه کرد. مدافعان مسئولیت&zwnj;های خود را شخصاً
            عهده&zwnj;دار می&zwnj;شوند، به طور مداوم فراتر می&zwnj;روند و هر
            کاری بتوانند انجام می&zwnj;دهند تا از انتظارات فراتر بروند و دیگران
            را در محل کار و در خانه شاد کنند.
          </p>{" "}
          <h2>ما باید دیده شویم تا باور شویم</h2>{" "}
          <p>
            چالش پیش روی افراد دارای گونه شخصیتی مدافع این است که مطمئن شوند
            آنچه که انجام می&zwnj;دهند مورد توجه قرار گیرد. آن&zwnj;ها تمایل
            دارند دستاوردهای خود را دست&zwnj;کم بگیرند، و اگرچه اغلب به محبت
            آنها احترام گذاشته می&zwnj;شود، امکان دارد افراد بدبین و خودخواه از
            فداکاری و فروتنی مدافعان سوءاستفاده کنند و کارها را به دوش آنها
            بیندازند و سپس اعتبارش را به نام خود ثبت کنند. مدافعان باید بدانند
            چه زمانی نه بگویند و اگر می&zwnj;خواهند اعتماد به نفس و اشتیاق خود
            را حفظ کنند باید از خود دفاع کنند.
          </p>{" "}
          <p>
            مدافعان به طور ذاتی اجتماعی هستند - که کیفیت عجیبی برای این گونه
            شخصیتی درونگرا است - و از حافظه عالی خود نه برای حفظ داده&zwnj;ها و
            چیزهای بی&zwnj;اهمیت بلکه برای به یاد آوردن افراد و جزئیات زندگی
            آنها استفاده می&zwnj;کنند. وقتی پای هدیه دادن به میان می&zwnj;آید،
            هیچ&zwnj;کس با مدافعان برابری نمی&zwnj;کند، آنها از تخیل و حساسیت
            طبیعی خود برای بیان سخاوت خویش به گونه&zwnj;ای استفاده می&zwnj;کنند
            که به قلب دریافت&zwnj;کنندگان هدایا نفوذ می&zwnj;کند. ابراز محبت
            گونه شخصیتی مدافع در خانواده به&zwnj;طور کامل شکوفا می&zwnj;شود،
            اگرچه این مسئله قطعاً در مورد همکاران چنین افرادی که آنها را دوستان
            شخصی تلقی می&zwnj;کنند نیز صادق است.
          </p>{" "}
          <h2>اگر بتوانم از تو محافظت کنم، این کار را می&zwnj;کنم</h2>{" "}
          <p>
            شخصیت&zwnj;های مدافع گروه فوق&zwnj;العاده&zwnj;ای هستند و تا زمانی
            که کار مهمی ناتمام مانده باشد، به&zwnj;ندرت بیکار می&zwnj;نشینند.
            توانایی مدافعان برای برقراری ارتباط با دیگران در سطح صمیمی در میان
            درونگراها بی&zwnj;نظیر است و لذتی که در استفاده از این ارتباطات برای
            حفظ خانواده&zwnj;ای حمایتگر و شاد تجربه می&zwnj;شود هدیه&zwnj;ای است
            که به همه افراد درگیر داده می&zwnj;شود. ممکن است مدافعان از اینکه در
            کانون توجه هستند واقعاً راحت نباشند و امکان دارد از اینکه نتیجه
            تلاش&zwnj;های تیمی به پای آنها نوشته شود احساس گناه کنند، اما اگر
            بتوانند مطمئن شوند که تلاش&zwnj;های آنها به رسمیت شناخته
            می&zwnj;شود، چنان احساس رضایتی به آنها دست خواهد داد که بسیاری از
            گونه&zwnj;های شخصیتی دیگر تنها می&zwnj;توانند آن را به خواب ببینند.
          </p>
        </article>
      </div>
    </div>
  );
}
